// src/components/pages/BundleThanksWrapperArea.jsx
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { SessionContext } from "../../common/SessionContext";

const scrollTop = () =>
  window.scrollTo({ top: 0, behavior: "smooth" });

export default function BundleThanksWrapperArea(props) {
  const { session } = useContext(SessionContext);
  const currentCurrency = session.currency;

  const API_URL = `${process.env.REACT_APP_API_FOLDER}get_bundle_purchase/${props.hash}`;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;
  const fetcher = url =>
    fetch(url, { headers: { "X-API-TOKEN": API_TOKEN } })
      .then(res => {
        if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
        return res.json();
      });

  const { data: bundle, error, isLoading } = useSWR(API_URL, fetcher);
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    if (!bundle?.bundle_code) return;
    navigator.clipboard.writeText(bundle.bundle_code)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => {});
  };

  if (isLoading) {
    return (
      <div className="contact-wrapper pt-110">
        <div className="container">
          <div className="row align-items-center justify-content-lg-center gy-5">
            <div className="col-lg-6">
              <Skeleton height={300} />
            </div>
            <div className="col-lg-5">
              <Skeleton height={40} width="60%" style={{ marginBottom: 16 }} />
              <Skeleton count={3} />
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (error) {
    return <p className="text-danger">Error loading bundle: {error.message}</p>;
  }

  return (
    <div className="contact-wrapper pt-110">
      <div className="container">
        <div className="row align-items-center justify-content-lg-center gy-5">
          <div className="col-lg-6">
            <div className="contatc-intro-figure">
              <img
                src={`${process.env.PUBLIC_URL}/images/banner/booked-bg.png`}
                alt="ContactBannerIMG"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="booked-info">
              <h3>Thanks!</h3>
              <p>
                We’ve sent an email to{" "}
                <span className="sent_email">{bundle.customer_email}</span>{" "}
                with confirmation of your bundle purchase. Your{" "}
                <strong>unique booking code</strong>, which you can now use to
                book workshops, is{" "}
                <span
                  onClick={copyToClipboard}
                  style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                  title="Click to copy"
                >
                  {bundle.bundle_code}
                </span>
                {copied && <span style={{ marginLeft: 10, color: "green" }}>Copied!</span>}
              </p>
              <p>
                Any problems or questions using your bundle, drop us a line at{" "}
                <a href="mailto:hello@campfr.com">hello@campfr.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
